import { useT } from "@transifex/react";
import { cp } from "../../config";

interface FooterLink {
    text: string;
    type: "link" | "modal";
    href?: string;
}

export const AreaFooter = () => {
    const t = useT();

    const t_termsOfService = t("Terms of Service", { _tags: "TeacherArea, FooterLink" });
    const t_privacyPolicy = t("Privacy Policy", { _tags: "TeacherArea, FooterLink" });
    const t_cookiePolicy = t("Cookie Policy", { _tags: "TeacherArea, FooterLink" });
    const t_imprint = t("Imprint", { _tags: "TeacherArea, FooterLink" });

    const baseStyles = "text-m text-p6-grey-dark hover:underline cursor-pointer";

    const footerLinks: FooterLink[] = [
        {
            href: `${cp.cfg.REACT_APP_P6_BASE_WEBSITE}schule/agb`,
            text: t_termsOfService,
            type: "link",
        },
        {
            href: `${cp.cfg.REACT_APP_P6_BASE_WEBSITE}schule/datenschutz`,
            text: t_privacyPolicy,
            type: "link",
        },
        {
            text: t_cookiePolicy,
            type: "modal",
        },
        {
            href: `${cp.cfg.REACT_APP_P6_BASE_WEBSITE}schule/impressum`,
            text: t_imprint,
            type: "link",
        },
    ];

    return (
        <footer className="p-m min-h-footer border-t-p6-grey-light flex items-center justify-center border-t bg-white">
            <div className="gap-s gap-y-xs flex flex-wrap justify-center">
                {footerLinks.map((link) =>
                    link.type === "modal" ? (
                        <button
                            key={`btn-${link.text.replace(/\s+/g, "-")}`}
                            id="cookie-prefs-btn"
                            className={`${baseStyles} p-no border-none bg-none`}
                            onClick={() => document.dispatchEvent(new CustomEvent("cookies:showPrefs"))}
                        >
                            {link.text}
                        </button>
                    ) : (
                        <a
                            key={`link-${link.text.replace(/\s+/g, "-")}`}
                            href={link.href}
                            className={baseStyles}
                        >
                            {link.text}
                        </a>
                    )
                )}
            </div>
        </footer>
    );
};
